/**
PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2025 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

/**
 * IframeWrapper component
 *
 * @file IframeWrapper.jsx
 * @author Ujjwal Sana
 * @since 0.0.1
 */

import React, {
  useState,
  useEffect,
  memo,
  useCallback
} from 'react';
import PropTypes from 'prop-types';
import LoadingContainer from '../LoadingContainer';
import { IframeWrapperLoader } from '../../../modules/authhome/Loader/ComponentLoader';
import * as constants from '../../constants';

const IframeWrapper = ({ embeddedUrl, closeDrawer }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const handleCloseDrawer = useCallback(closeDrawer, []);

  useEffect(() => {
    setTimeout(() => {
      setIsLoaded(true); // iframe is visible, hide loader
      handleCloseDrawer();
    }, constants.DELAY_FOR_LEFT_NAV);
  }, []);

  return (
    <div>
      <iframe
        className="pplus-iframe-wrapper"
        title="studyprep"
        src={embeddedUrl}
      />
      <LoadingContainer isReadyToRender={isLoaded} loader={<IframeWrapperLoader />} />
    </div>
  );
};

IframeWrapper.propTypes = {
  embeddedUrl: PropTypes.string.isRequired,
  closeDrawer: PropTypes.func.isRequired
};

export default memo(IframeWrapper);
